import React from "react";

import styles from "./NavItem.module.scss";

export default function NavItem({ icon, title, active, onClick, className }) {
  const activeStyleObserver = () => {
    if (active) return styles.active;
    return;
  };

  return (
    <div
      className={`${styles.container} ${activeStyleObserver()} ${className}`}
      onClick={onClick}
    >
      <div className={`${styles.icon}`}>{icon}</div>
      <p className={`${styles.title}`}> {title}</p>
    </div>
  );
}
